import { z } from 'zod';
/**
 * Wire primitives — model what the handlers ACTUALLY send today.
 * (Money is a 2dp JS number on the wire; integer øre is a future, separate
 *  breaking change. Every denominator-guarded value is number | null.)
 */
export const isoDate = z.string().regex(/^\d{4}-\d{2}-\d{2}$/, 'expected YYYY-MM-DD');
/** timestamptz columns serialize as ISO strings in JSON (createdAt/updatedAt). */
export const isoTimestamp = z.string();
/** NOK (and AED) money — a JS number, 2dp, as the handlers emit it. */
export const nokAmount = z.number();
/** A ratio/derived value guarded by a zero-denominator check → number | null. */
export const ratio = z.number().nullable();
/** A count (impressions/clicks/bookings/…). Kept loose (not .int()) so a
 *  surprise value can never break the typed client's response .parse(). */
export const count = z.number();
export const segmentEnum = z.enum(['all', 'lead', 'booking']);
export const formatEnum = z.enum(['int', 'nok', 'aed', 'pct', 'ratio', 'text']);
export const sourceEnum = z.enum(['meta', 'momence', 'stripe', 'derived']);
export const comparatorEnum = z.enum(['gte', 'lte']);
export const severityEnum = z.enum(['info', 'warn', 'critical']);
//# sourceMappingURL=primitives.js.map